import { HttpRequest } from './HttpRequest'

export const GetCRNamedRequest = async (projectId: string) => {
    try { 
        const response = await HttpRequest().get(`/crname/projectid/${projectId}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        return []
    }
}

export const GetCRNamePJByProjectId = async (projectId: string) => {
    try {
        const response = await HttpRequest().get(`/crname/pj/projectid/${projectId}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
    } catch (error) {
        return []
    }
}